import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Footer = ({ onLogout }) => {
  const { user } = useAuth();
  
  // Vérifier si l'utilisateur est admin (même logique que le backend)
  const isAdmin = user?.email === 'contact@dismaman.com';

  return (
    <footer className="fixed bottom-0 left-0 right-0 py-3 z-40 bg-transparent">
      <div className="container mx-auto px-4 flex justify-center items-center gap-4">
        <button
          onClick={onLogout}
          className="text-gray-600 hover:text-red-500 text-sm font-medium transition-colors duration-300 px-3 py-1 rounded-full hover:bg-white/50"
          data-testid="logout-button"
          style={{ textShadow: '0 1px 2px rgba(255,255,255,0.8)' }}
        >
          🚪 Déconnexion
        </button>
        
        {isAdmin && (
          <Link
            to="/admin"
            className="text-gray-500 hover:text-gray-700 text-sm transition-colors duration-300 px-3 py-1 rounded-full hover:bg-white/50"
            data-testid="admin-link"
            style={{ textShadow: '0 1px 2px rgba(255,255,255,0.8)' }}
          >
            ⚙️ Admin
          </Link>
        )}
      </div>
    </footer>
  );
};

export default Footer;